import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { getDocumentDisplayName } from "../../api/engineerApi";

function UpdateStandardDocument({
  documentName,
  uploadDocToClientFunc,
  handleDocExpiryFunc,
  formError,
  hideExpiry,
  issuedDate = false,
}) {
  const cameraInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const [pendingFileName, setPendingFileName] = useState(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setPendingFileName(e.target.files[0].name);
      uploadDocToClientFunc(e);
    }
  };

  return (
    <div className="row">
      <div className="form-group mb-3">
        <label className="form-label">{getDocumentDisplayName(documentName)}</label>

        <input ref={cameraInputRef} type="file" accept="image/*" capture="environment" className="d-none" onChange={handleFileChange} />
        <input ref={fileInputRef} type="file" accept="image/*, .pdf" className="d-none" onChange={handleFileChange} />

        <div className="d-flex gap-2">
          <button type="button" className="btn btn-outline-secondary btn-sm flex-fill" onClick={() => cameraInputRef.current.click()}>
            📷 Camera
          </button>
          <button type="button" className="btn btn-outline-secondary btn-sm flex-fill" onClick={() => fileInputRef.current.click()}>
            Upload
          </button>
        </div>
        {pendingFileName && (
          <p className="text-muted small mt-2 fst-italic mb-0">{pendingFileName}</p>
        )}
      </div>
      {hideExpiry ? (
        ""
      ) : (
        <div className="form-group mb-3">
          <label htmlFor="inputDocumentExpiryDate">
            {issuedDate === false
              ? `Date your ${getDocumentDisplayName(documentName)} expires`
              : `Date your ${getDocumentDisplayName(documentName)} was issued`}
          </label>
          <input
            type="date"
            className="form-control"
            id="inputDocumentExpiryDate"
            name="documentExpiryDate"
            onChange={handleDocExpiryFunc}
            required
          />
        </div>
      )}
      {formError ? <p className="fw-bold text-danger">*Please fill in all details</p> : <></>}
    </div>
  );
}

UpdateStandardDocument.propTypes = {
  documentName: PropTypes.string.isRequired,
  uploadDocToClientFunc: PropTypes.func.isRequired,
  handleDocExpiryFunc: PropTypes.func,
  formError: PropTypes.bool.isRequired,
  hideExpiry: PropTypes.bool,
  issuedDate: PropTypes.bool,
};

export default UpdateStandardDocument;
